import { messages as arabicMessages } from "./ar";
import { messages as germanMessages } from "./de";
import { messages as englishMessages } from "./en";
import { messages as spanishMessages } from "./es";
import { messages as frenchMessages } from "./fr";
import { messages as hindiMessages } from "./hi";
import { messages as indonesianMessages } from "./id";
import { messages as italianMessages } from "./it";
import { messages as japaneseMessages } from "./ja";
import { messages as portugueseMessages } from "./pt";
import { messages as russianMessages } from "./ru";
import { messages as chineseMessages } from "./zh";

const messages = {
	pt: portugueseMessages.pt,
	en: englishMessages.en,
	es: spanishMessages.es,
	fr: frenchMessages.fr,
	de: germanMessages.de,
	it: italianMessages.it,
	zh: chineseMessages.zh,
	ja: japaneseMessages.ja,
	ru: russianMessages.ru,
	ar: arabicMessages.ar,
	hi: hindiMessages.hi,
	id: indonesianMessages.id,
};

export { messages };

